import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var CountChipBlock = styled.div.withConfig({
  displayName: "partials__CountChipBlock",
  componentId: "sc-ejab6q-0"
})(["display:flex;align-items:center;height:24px;padding:0 8px;padding:6px 8px;border-radius:16px;cursor:pointer;background-color:", ";", ";span{:nth-child(2){margin-left:", ";color:", ";transition:color 0.5s ease;}}&:hover{span{:nth-child(2){color:", ";}}}svg{width:14px;height:14px;margin-top:4px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.ui;
}, getFont(-1, 'compact'), function (_ref2) {
  var withClose = _ref2.withClose;
  return withClose ? '4px' : '0px';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.terciary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.terciaryD;
});